<template>
  <div
    class="custom-message-component-kkbutton-container"
    :style="{
      width:style.width,
      height:style.height,
      padding,
    }"
    @click="clickHandle"
  >
    <span
      class="custom-message-component-kkbutton-container-text"
      :style="{
        fontSize:style.fontSize,
        fontWeight:style.fontWeight,
        color:style.color,
        lineHeight: style.lineHeight,
      }"
    >
      {{ text }}
    </span>
    <div class="custom-message-component-kkbutton-container-content">
      <div
        class="custom-message-component-kkbutton-container-content-left-block"
        :style="{
          backgroundColor:style.backgroundColor,
        }"
      />
      <div
        class="custom-message-component-kkbutton-container-content-main-block"
        :style="{
          backgroundColor:style.backgroundColor,
          height:style.height,
        }"
      />
      <div
        class="custom-message-component-kkbutton-container-content-right-block"
        :style="{
          backgroundColor:style.backgroundColor,
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" >
import {
  CustomMessageKKButtonComponent,
} from '_c/typings/model/chat/text-node';
import { pushUrl, getWidth } from '@/business/chat/custom-message-util';
import { defineComponent, computed, PropType, toRaw } from 'vue';


export default defineComponent({
  name: 'CustomMessageKKButton',
  props: {
    attr: {
      type: Object as PropType<CustomMessageKKButtonComponent>,
      required: true,
    },
  },
  setup(props) {
    let scale = 1;
    const attr = toRaw(props.attr);
    if (attr.scale) {
      scale = toRaw(attr.scale);
    }
    const color = toRaw(attr.style?.color) as string;
    const bgColor = toRaw(attr.color) as string;
    const { text } = attr;
    let width = getWidth(props.attr.width, scale);
    if (parseInt(width, 10) > 316) {
      width = '316px';
    }
    const style = {
      url: attr.onClick?.uri ?? '',
      width,
      height: attr.height ? `${attr.height * scale}px` : '100%',
      lineHeight: attr.height ? `${(attr.height * scale) - 1}px` : '100%',
      disabled: !attr.enable,
      fontSize: attr.style?.fontSize ? `${attr.style.fontSize * scale}px` : '26px',
      fontWeight: attr.style?.fontWeight ?? 500,
      color: attr.style?.color ? '#'.concat(color.slice(4), color.slice(2, 4)) : '#333333',
      backgroundColor: attr.color ? '#'.concat(bgColor.slice(4), bgColor.slice(2, 4)) : '#3FFF88',
    };
    const padding = computed(() => {
      if (!attr.padding) return '0px';
      const { left, top, bottom, right } = attr.padding;
      const str = `${(top ? top : 0 * scale) / 2}px ${(right
        ? right
        : 0 * scale) / 2}px ${(bottom ? bottom : 0 * scale)
      / 2}px ${(left ? left : 0 * scale) / 2}px`;
      return str;
    });
    const asideWidth = `${8 * scale}px`;
    function clickHandle(e: Event): void {
      if (attr.onClick) {
        e.stopPropagation();
        pushUrl(attr.onClick, attr.reportData);
      }
    }
    return {
      clickHandle,
      style,
      padding,
      text,
      asideWidth,
    };
  },
});

</script>

<style scoped lang="scss">
.custom-message-component-kkbutton-container {
  position: relative;
  cursor: pointer;

  &-text {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-style: normal;
    z-index: 2;
    white-space: nowrap;
  }

  &-content {
    height: 100%;

    &-right-block {
      position: absolute;
      height: auto;
      top: v-bind('asideWidth');
      bottom: v-bind('asideWidth');
      right: 0;
      width: v-bind('asideWidth');
    }

    &-left-block {
      position: absolute;
      height: auto;
      top: v-bind('asideWidth');
      bottom: v-bind('asideWidth');
      left: 0;
      width: v-bind('asideWidth');
    }

    &-main-block {
      position: absolute;
      left: v-bind('asideWidth');
      right: v-bind('asideWidth');
    }
  }
}
</style>
